export const POSITION_TAGS_EXPERIENCE_OPTIONS = [
    {
        label: $filter("translate")("0 - 1 year"), 
        value: 0
    },
    {
        label: $filter("translate")("1 - 2 years"), 
        value: 1
    },
    {
        label: $filter("translate")("2 - 3 years"), 
        value: 2
    },
    {
        label: $filter("translate")("3 - 4 years"), 
        value: 3
    },
    {
        label: $filter("translate")("4 - 5 years"), 
        value: 4
    },
    {
        label: $filter("translate")("5+ years"), 
        value: 5
    },
];

export const MAX_YEARS_OF_EXPERIENCE = 100;